export const BRANCH_CAST_ENTRY = {
  Computer: "COMP",
  "Information Technology": "IT",
  "Electronics & Telecommunication": "EXTC",
  Civil: "CIVIL",
  "Mechanical Section A": "MECH_A",
  "Mechanical Section B": "MECH_B",
  Instrumentation: "INST",
  "ASH Department": "ASH",
  "Artificial Inteligence & Data Science": "AIDS",
  "Computer Science / Data Science": "CSE/DS",
};

export const BRANCH_CAST_ACCOUNT = {
  Computer: "COMP",
  "Information Technology": "IT",
  "Electronics & Telecommunication": "EXTC",
  Civil: "CIVIL",
  Mechanical: "MECH",
  Instrumentation: "INST",
  "ASH Department": "ASH",
  "Artificial Inteligence & Data Science": "AIDS",
  "Computer Science / Data Science": "CSE/DS",
};

export const CLASS_CAST = {
  "First Year": "FE",
  "Second Year": "SE",
  "Third Year": "TE",
  "Fourth Year": "BE",
  Departmental: "D",
};

export const ENTRY_TYPE = {
  "Intra College": "INTRA",
  "Inter College": "INTER",
};
